<template>
  <div id="download-area" class="w-100">
    <div class="container download-area-content-wrapper">
      <div class="download-area-left">
        <div class="image-success-wrapper">
          <img :src="successImage" alt="success-image" width="150px">
        </div>
        <div class="greeting-left">
          <div class="greeting-left-value">Selamat Anda sudah menyelesaikan semua aktivitas program</div>
        </div>
      </div>
      <div class="download-area-right">
        <div class="right-content-wrapper">
          <div class="greeting-right">
            <div class="gretting-right-value">Anda berhasil mendapatkan sertifikat kepesertaan program ini</div>
          </div>
          <div class="button-download-wrapper">
            <s-button
              cluster="k"
              tag="button"
              variant="primary"
              size="small"
              @click="downloadPDF"
              class="w-100 s-mb-3"
            >
              Unduh versi PDF
            </s-button>
            <s-button
              v-if="sertifikatImage && sertifikatImage.length === 1"
              cluster="k"
              tag="button"
              variant="secondary"
              size="small"
              @click="downloadImage"
              class="w-100"
            >
              Unduh versi Gambar
            </s-button>
            <!--
            <div class="share-button" @click.prevent="openShareModal">
              <img :src="shareIcon" alt="share-icon" width="30px">
              <div class="share-text-value gotham-bold">Bagikan Sertifikat</div>
            </div>
            -->
          </div>
        </div>
      </div>
      <!-- <share-modal :openModal="showShareModal" @closeModal="closeShareModal" /> -->
    </div>
  </div>
</template>

<script>
import ImageSertifikat from '../../assets/images/sertifikat/index'
// import ShareModal from '../../components/sertifikat/ShareSertifikatModal'

export default {
  name: 'DownloadArea',
  components: {
    // ShareModal
  },
  data: () => ({
    successImage: ImageSertifikat.success,
    shareIcon: ImageSertifikat.share,
    showShareModal: false
  }),
  methods: {
    openShareModal () {
      this.showShareModal = true
    },
    closeShareModal () {
      this.showShareModal = false
    },
    downloadImage () {
      window.open(this.sertifikatImage[0])
    },
    downloadPDF () {
      window.open(this.sertifikatPDF)
    }
  },
  computed: {
    sertifikatPDF () {
      return this.$store.state.certificate.currentCertificate.url_pdf
    },
    sertifikatImage () {
      return this.$store.state.certificate.currentCertificate.url_image
    }
  }
}
</script>

<style scoped>
.download-area-content-wrapper {
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 20px;
  margin-top: 20px;
  margin-bottom: 50px;
  padding: 20px;
  display: flex;
  align-items: center;
  width: 60%;
}

.download-area-left {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.greeting-left {
  margin-top: 8px;
}

.greeting-left-value {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}

.download-area-right {
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.right-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.greeting-right {
  text-align: center;
  width: 90%;
}

.greeting-right-value {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}

.button-download-wrapper {
  display: flex;
  flex-direction: column;
  width: 70%;
  padding: 10px 0px;
}

.share-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.share-text-value {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #3498DB;
}

@media screen and (max-width: 1024px) {
  .download-area-content-wrapper {
    width: 70%;
  }
}

@media screen and (max-width: 768px) {
  .download-area-content-wrapper {
    width: 90%;
  }
}
</style>
